import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Download, FileText, Lock } from "lucide-react";

const SECTIONS = [
  {
    t: "Préambule",
    items: [
      { b: "La présente Politique de Confidentialité décrit comment STUDEUR SARL (« LéoParts », « nous ») collecte, utilise, conserve et protège les données personnelles des utilisateurs de la Plateforme." },
      { b: "LéoParts est une plateforme d'investissement participatif permettant aux investisseurs congolais (résidents et diaspora) de financer des projets majeurs nationaux en partenariat avec CADECO. La protection de vos données est au cœur de nos préoccupations." },
      { b: "Cette politique est conforme au droit en vigueur en RDC : Loi n° 20/017 du 25 novembre 2020 (TIC), Ordonnance-Loi n° 23/010 du 13 mars 2023 (Code du numérique, Livre III), et la Convention de Malabo ratifiée par la RDC le 27 juin 2025. Pour les résidents de l'UE, elle intègre le RGPD (UE 2016/679)." },
    ],
  },
  {
    t: "1. Définitions",
    items: [
      { list: ["Donnée à caractère personnel : toute information relative à une personne physique identifiée ou identifiable.", "Traitement : toute opération appliquée à des données (collecte, enregistrement, conservation, effacement, etc.).", "Responsable du traitement : STUDEUR SARL, qui détermine les finalités et moyens du traitement.", "Sous-traitant : toute personne traitant des données pour le compte du responsable.", "Personne concernée : vous, en tant qu'utilisateur de la Plateforme."] },
    ],
  },
  {
    t: "2. Responsable du traitement & DPO",
    items: [
      { h: "2.1 Responsable du traitement", b: "STUDEUR SARL, société de droit congolais immatriculée au RCCM, siège social à Kinshasa, RDC." },
      { h: "2.2 Délégué à la Protection des Données (DPO)", b: "Conformément à l'article 262 du Code du numérique, un DPO est joignable à : dpo@leoparts.cd." },
    ],
  },
  {
    t: "3. Données collectées",
    items: [
      { h: "3.1 Données fournies directement", table: [["Catégorie", "Données", "Finalité"], ["Identité", "Nom, prénom, naissance, nationalité, n° d'identification", "Compte, KYC, obligations légales"], ["Contact", "Email, téléphone, adresse, pays", "Communication, conformité"], ["Bancaires", "IBAN, BIC, RIB", "Dividendes, retraits, paiements"], ["Biométriques", "Photo d'identité, selfie (liveness)", "KYC, vérification d'identité"], ["Investissement", "Montants, projets, historique", "Exécution & suivi du portefeuille"]] },
      { h: "3.2 Données collectées automatiquement", b: "Données de connexion (IP anonymisée après 30 j), de navigation, d'appareil et de performance — pour la sécurité, la prévention de la fraude et l'amélioration du service." },
      { h: "3.3 Données sensibles", b: "LéoParts ne collecte aucune donnée révélant l'origine raciale, les opinions politiques, les croyances, la santé ou la vie sexuelle, conformément à la loi congolaise." },
    ],
  },
  {
    t: "4. Bases légales du traitement",
    items: [
      { table: [["Base légale", "Exemples"], ["Consentement", "Newsletters, cookies publicitaires, partage avec des tiers"], ["Exécution du contrat", "Compte, investissements, versement des dividendes"], ["Obligation légale", "Conservation (5 ans), KYC, déclarations fiscales"], ["Intérêt légitime", "Analyse d'audience, prévention de la fraude, amélioration"]] },
    ],
  },
  {
    t: "5. Finalités & durées de conservation",
    items: [
      { table: [["Finalité", "Durée"], ["Gestion du compte", "Durée du compte + 5 ans"], ["KYC", "5 ans après clôture"], ["Investissements & dividendes", "Durée de l'investissement + 10 ans"], ["Communication", "Jusqu'à désinscription"], ["Analyse statistique", "13 mois (anonymisées)"], ["Conformité fiscale", "10 ans (loi comptable)"], ["Prévention fraude / sécurité", "5 ans"], ["Marketing", "Jusqu'au retrait du consentement"]] },
    ],
  },
  {
    t: "6. Cookies & technologies de suivi",
    items: [
      { b: "Un cookie est un petit fichier déposé sur votre appareil lors de la navigation." },
      { table: [["Type", "Finalité", "Consentement"], ["Strictement nécessaires", "Authentification, sécurité, langue", "Non"], ["Préférences", "Affichage mémorisé", "Oui"], ["Analytiques", "Mesure d'audience anonymisée", "Oui"], ["Publicitaires", "Publicités personnalisées", "Oui"]] },
      { b: "Lors de votre première visite, un bandeau vous permet de paramétrer vos préférences. Vous pouvez les modifier via « Gérer les cookies » ou configurer votre navigateur." },
    ],
  },
  {
    t: "7. Destinataires des données",
    items: [
      { b: "Vos données sont accessibles aux personnels habilités de STUDEUR (technique, administratif, commercial), à CADECO (compte, paiements, KYC), et aux autorités de régulation (ARPTIC, BCC) sur réquisition légale." },
      { h: "Sous-traitants", b: "Hébergeur cloud, Stripe/Dlocal (cartes, PCI-DSS), Mobile Money (M-Pesa, Orange, Airtel), Yousign (signature), Google Analytics (IP anonymisée), service de vérification KYC, Twilio/Sendinblue (notifications). Aucune donnée n'est vendue à des tiers." },
    ],
  },
  {
    t: "8. Transferts internationaux",
    items: [
      { b: "Certains sous-traitants sont situés hors RDC (UE, États-Unis). Des garanties appropriées sont mises en place (Clauses Contractuelles Types, RGPD, Data Privacy Framework). Les données de connexion sont conservées 12 mois (Loi n° 20/017, art. 142)." },
    ],
  },
  {
    t: "9. Vos droits",
    items: [
      { list: ["Droit d'accès : obtenir une copie de vos données.", "Droit de rectification : corriger des données inexactes.", "Droit à l'effacement (« droit à l'oubli »), sous réserve des obligations légales.", "Droit à la limitation du traitement.", "Droit d'opposition (notamment marketing direct).", "Droit à la portabilité de vos données.", "Droit de retirer votre consentement à tout moment.", "Droit d'introduire une réclamation (ARPTIC en RDC ; CNIL, APD… dans l'UE)."] },
      { h: "Comment exercer vos droits", b: "Contactez le DPO à dpo@leoparts.cd. Réponse sous 30 jours maximum (prolongeable de 2 mois pour les demandes complexes). Une pièce d'identité peut être demandée." },
    ],
  },
  {
    t: "10. Sécurité des données",
    items: [
      { h: "Mesures techniques", b: "Chiffrement TLS 1.3, mots de passe hashés (bcrypt), double authentification (2FA) pour les opérations sensibles, sauvegardes quotidiennes chiffrées, journalisation des accès et en-têtes de sécurité (CSP, X-Frame-Options, etc.)." },
      { h: "Mesures organisationnelles", b: "Formation du personnel, accès strictement limité (besoin d'en connaître), contrats de sous-traitance incluant des clauses de confidentialité." },
      { h: "Notification en cas de violation", b: "En cas de violation à risque, LéoParts vous notifie sans délai indu et au plus tard sous 72 heures, et informe l'autorité de contrôle compétente." },
    ],
  },
  {
    t: "11. Mineurs",
    items: [
      { b: "La Plateforme n'est pas destinée aux personnes de moins de 18 ans. LéoParts ne collecte pas sciemment de données auprès de mineurs. Tout parent/tuteur constatant une telle collecte peut écrire à dpo@leoparts.cd pour suppression." },
    ],
  },
  {
    t: "12. Modifications & contact",
    items: [
      { b: "Toute modification substantielle est notifiée par bandeau et par email au moins 15 jours avant son entrée en vigueur. La date de dernière mise à jour figure en tête du document." },
      { h: "Contacts", b: "DPO : dpo@leoparts.cd · Support : support@leoparts.cd · Sécurité : security@leoparts.cd. Adresse : STUDEUR SARL – LéoParts, Kinshasa, RDC." },
    ],
  },
];

export default function PrivacyPage() {
  return (
    <Layout>
      <div className="bg-slate-900">
        <div className="max-w-3xl mx-auto px-4 py-12">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-3 py-1 text-white text-xs font-semibold"><Lock className="h-3.5 w-3.5 text-congo-gold" /> Protection des données</div>
          <h1 className="font-head text-3xl sm:text-4xl font-bold text-white mt-4">Politique de Confidentialité</h1>
          <p className="text-slate-300 mt-3 text-sm">Responsable du traitement : STUDEUR SARL · Partenaire bancaire : CADECO · DPO : dpo@leoparts.cd</p>
          <a href="/leoparts-confidentialite.pdf" download data-testid="download-privacy-btn">
            <Button className="mt-5 rounded-full bg-congo-gold text-slate-900 hover:bg-congo-golddark font-semibold"><Download className="h-4 w-4 mr-2" /> Télécharger le PDF</Button>
          </a>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-10" data-testid="privacy-content">
        {SECTIONS.map((s) => (
          <section key={s.t} className="mb-8">
            <h2 className="font-head text-xl font-bold text-congo-blue border-b border-slate-200 pb-2 mb-4 flex items-center gap-2"><FileText className="h-5 w-5" /> {s.t}</h2>
            <div className="space-y-4">
              {s.items.map((it, i) => (
                <div key={it.h || it.b || `item-${i}`}>
                  {it.h && <h3 className="font-semibold text-slate-900">{it.h}</h3>}
                  {it.b && <p className="text-slate-600 leading-relaxed mt-1">{it.b}</p>}
                  {it.list && (
                    <ul className="mt-2 space-y-1.5">
                      {it.list.map((li) => (
                        <li key={li} className="text-slate-600 flex items-start gap-2"><span className="mt-2 h-1.5 w-1.5 rounded-full bg-congo-gold shrink-0" />{li}</li>
                      ))}
                    </ul>
                  )}
                  {it.table && (
                    <div className="mt-3 overflow-x-auto">
                      <table className="w-full text-sm border border-slate-200 rounded-lg overflow-hidden">
                        <thead className="bg-slate-50">
                          <tr>{it.table[0].map((c) => <th key={c} className="text-left font-semibold text-slate-700 px-3 py-2 border-b border-slate-200">{c}</th>)}</tr>
                        </thead>
                        <tbody>
                          {it.table.slice(1).map((row, ri) => (
                            <tr key={row[0] || `row-${ri}`} className="border-b border-slate-100 last:border-0">
                              {row.map((c, ci) => <td key={ci} className={`px-3 py-2 ${ci === 0 ? "font-medium text-slate-800" : "text-slate-600"}`}>{c}</td>)}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
        ))}
        <p className="text-xs text-slate-400 border-t border-slate-200 pt-4">Document conforme au droit congolais et aux standards internationaux. À faire valider par un conseil juridique avant mise en production.</p>
      </div>
    </Layout>
  );
}
